import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

import ListaDeMonedasConstant from 'constants/listaDeMonedas'

// TODO > Consistenciar constantes
const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback((e) => {
    KeyEventUtil.leaveOnEnterOrTab('select-cuentaContablePago', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-monedaPago' md={4} size='sm' />
      <Col md={8}>
        <Field name='monedaPago'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-monedaPago'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            >
              <option value={ListaDeMonedasConstant.SOLES}>SOLES</option>
              <option value={ListaDeMonedasConstant.DOLARES}>DOLARES</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
